import styles from './styles.module.scss'
export const WavyButton = ({ children, handleClick }) => {
  return (
    <div onClick={handleClick} className={styles.wavyButton}>
      {children}
    </div>
  )
}
